import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton, Highlight } from '@node-space/ui-components'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { type Invoice } from './types'
import { getInvoiceStatusTag } from './utils'

interface BillingSidePanelHeaderProps {
  invoice: Invoice
}

export const BillingSidePanelHeader = ({ invoice }: BillingSidePanelHeaderProps) => {
  const { t } = useTranslation()

  const statusTag = getInvoiceStatusTag(invoice.status, t)
  const iconsUrl = process.env.ICONS_URL
  const iconUrl =
    iconsUrl && invoice.currency ? `${iconsUrl}${invoice.currency.toLowerCase()}.svg` : ''

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: iconUrl ? [iconUrl] : [],
        secondaryLabel: invoice?.merchantName,
        primaryLabel:
          `${invoice.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${invoice.currency}`.trim(),
      }}
    >
      <Box flexCol className="pl-10">
        <Box flex gapX={4} className="mb-[6px]">
          <p className="text-foreground-prominent text-body-regular">{invoice?.id}</p>
          <CopyButton copyText={invoice?.id} />
        </Box>
        <Box>
          <Highlight type={statusTag.state}>{statusTag.label}</Highlight>
        </Box>
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}
